import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Slider } from "react-burgers";
import cx from 'classnames';
import { faEllipsisV, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import { setEnableMobileMenu, setEnableMobileMenuSmall } from '../../reducers/ThemeOptions';
import { useDispatch } from 'react-redux';
import { setMenuMobileShow, setMenuUserShow, setMenuMainMobileShow } from "../../reducers/models/menuData";
import { useSelector } from 'react-redux';

function Index() {

    const dispatch = useDispatch()
    const stateMenu = useSelector((state) => state.menuData);//Настройки приложения

    //console.log('stateMenu.menuMainShow', stateMenu.menuMainShow)
    return (
        <Fragment>
            <div className="app-header__mobile-menu">
                <div>
                    {stateMenu.menuMainMobileShow === true && (
                        <Slider
                            active={true}
                            type="elastic"
                        />
                    )}
                    {stateMenu.menuMainMobileShow === false && (
                        <Slider
                            active={false}
                            type="elastic"
                            onClick={(e) => { dispatch(setMenuMainMobileShow({ data: true })); }}
                        />
                    )}
                </div>
            </div>
            <div className="app-header__menu">
                <span /*onClick={this.toggleMobileSmall}*/>
                    <Button size="sm"
                        className={cx("btn-icon btn-icon-only", { active: true })}
                        color="primary"
                        onClick={() => { dispatch(setMenuMobileShow({ data: !stateMenu.menuMobileShow })) }}>
                        <div className="btn-icon-wrapper"><FontAwesomeIcon icon={faEllipsisV} /></div>
                    </Button>
                </span>
            </div>
        </Fragment>
    )
}

export default Index;